import { useParams } from 'react-router'
import { useAuth0 } from '@auth0/auth0-react'
import { Box } from '@mui/material'
import PersonAddIcon from '@mui/icons-material/PersonAdd'

import AuthLoadingScreen from '../../components/AuthLoadingScreen/AuthLoadingScreen.component'

const Signup = (): JSX.Element => {
  const { loginWithRedirect } = useAuth0()
  const { redirect } = useParams<{ redirect?: string }>()

  loginWithRedirect({
    authorizationParams: {
      scope: 'profile email read:current_user',
      screen_hint: 'signup',
    },
    appState: { redirectUrl: redirect ? decodeURIComponent(redirect) : '/' },
  })

  return (
    <AuthLoadingScreen
      title="Redirecting to Sign up"
      subtitle="Please wait while we connect you securely…"
      icon={
        <Box
          sx={{
            width: 64,
            height: 64,
            borderRadius: '50%',
            background: 'linear-gradient(135deg, #007C91 0%, #00ACC1 100%)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            boxShadow: '0 4px 16px rgba(0, 124, 145, 0.3)',
          }}
        >
          <PersonAddIcon sx={{ fontSize: 30, color: 'white' }} />
        </Box>
      }
    />
  )
}

export default Signup
